import { Component, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { CardsService } from 'src/app/shared/services/cards.service';
import { CatalogsService } from 'src/app/shared/services/catalogs.service';
import { Card } from '../../shared/models/cards';
import notify from 'devextreme/ui/notify';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import { ProgramsService } from 'src/app/shared/services/programs.service';

@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.scss']
})
export class CardsComponent implements OnInit {
  _subscriptions: Subscription[] = [];
  cardsList: Card[] = [];
  cardDetails: Card;
  cardProviders = [];
  cardBrands = [];
  programsList = [];
  popupVisible = false;
  newCard: any;


  constructor(
    private catalogsService: CatalogsService,
    private cardsService: CardsService,
    private programsService: ProgramsService,
    private utilitiesService: UtilitiesService,
  ) {
    this.cardProviders = this.catalogsService.getCardProviders();
    this.cardBrands = this.catalogsService.getCardBrands();
  }

  ngOnInit() {
    this._subscriptions.push(
      this.cardsService.getCards().subscribe(cards => {
        this.cardsList = cards;
      })
    );
    this._subscriptions.push(
      this.programsService.getPrograms().subscribe(programs => {
        this.programsList = programs;
        //  console.log(this.programsList);
      })
    );
  }
  onKeypressEvent(e) {
    console.log(e);
  }

  checkCard() {
    const serialTo = Number(this.newCard.serialFrom) + Number(this.newCard.numberOfCards);
    this.newCard.serialTo = String(serialTo);
  }

  setStateValue(rowData: any, value: any): void {
    rowData.programName = null;
    (<any>this).defaultSetCellValue(rowData, value);
  }

  ngOnDestroy() {
    this._subscriptions.forEach((sub) => sub.unsubscribe);
  }

  newCardForm() {
    this.popupVisible = true;
    this.newCard = new Card();
    this.newCard.tempExpirationDate = null;
  }
  addNewCard(data) {
    if (data.validationGroup.validate().isValid) {
      const newCardData = this.newCard;
      newCardData.expirationDate = this.utilitiesService.dateToNumber(newCardData.tempExpirationDate);
      delete newCardData.tempExpirationDate;
      newCardData.registrationDate = this.utilitiesService.dateToNumber(new Date());
      //delete newCardData.id;
      const tempProgName = this.programsList.filter(program => program.name === newCardData.programName);
      newCardData.programId = tempProgName[0].id;
      newCardData.inventory = newCardData.numberOfCards;
      console.log('objeto listo para firebase', newCardData);
      this.cardsService.newCard(newCardData).then(data => {
        /*notify({
          message: 'Ejecutado exitosamente!',
          type: 'Success',
          displayTime: 2000,
          position: 'top right',
          height: '55px',
          shading: false,
          closeOnOutsideClick: true,
          width: '120px',
          maxWidth: '120px',
        });*/
        this.utilitiesService.notifyMeAndRedirect('Ejecutado exitosamente!', 'success', '/dash/cards')
      });
    }
  }

  updateCard(e) {
    const updateCardData = e.newData;
    updateCardData.expirationDate = this.utilitiesService.dateToNumber(updateCardData.tempExpirationDate);
    delete updateCardData.tempExpirationDate;
    updateCardData.registrationDate = this.utilitiesService.dateToNumber(new Date());
    console.log('objeto listo para firebase', updateCardData);
    this.cardsService.updateCard(e.key, updateCardData).then(data => {
      this.utilitiesService.notifyMe('Ejecutado exitosamente!', 'success');
    });
  }

  deleteCard(e) {
    this.cardsService.deleteCard(e.key).then(data => {
      this.utilitiesService.notifyMe('Ha sido eliminado', 'success');
    });
  }

}